module.exports = __webpack_public_path__ + "static/beauty10-59930abe87f9d8e8a586d8aaa826d420.jpg";